module.exports = __webpack_public_path__ + "img/postel.fa0d26fb.png";